import React from 'react'
import LoaderDots from "../../Modal/components/LoaderDots";
import Select from '../../miscellaneous/CustomSelect/CustomSelect'
import Tag from '../../miscellaneous/Tags/Tag'

const AddReporte = (props) => {
  const { state, indicador } = props
  const getFileNames = files => {
    let names = []
    for (let i = 0; i < files.length; i++) {
      names.push(files[i].name)
    }
    return names.map((f, i) => <Tag text={f} item={f} buttonHandler={props.removeFile} key={`file-key-report-${i}`} noClose={false} />)
  }
  const getMetaXyear = year => {
    return Math.round(100 * props.indicador.reportes.filter(f => f.anualidad === year).reduce((pre, cur) => pre + cur.value, 0)) / 100
  }
  console.log('p', props)
  return (
    <>
      <input
        id='reporte-input-file'
        type="file"
        style={{ display: 'none' }}
        onChange={props.fileChange}
        multiple
      ></input>
      <div style={{ minHeight: '205px' }}>
        <div className="modal-title-header">
          <div className='title-modal-kml-input no-select'>Agregar Reportes</div>
          <div className='add-button'><i className="fas fa-times on-mouse-hover" onClick={props.close}></i></div>
        </div>
        <div>
          <div className='add-reporte-info'>
            <div className='text-information-report'>
              <label>Linea</label>
              <p>{indicador.linea}</p>
            </div>
            <div className='text-information-report'>
              <label>Indicador</label>
              <p>{indicador.indicador}</p>
            </div>
            <div className='flex-space-between'>
              <div className='text-information-report'>
                <label>Meta 2020</label>
                <p>{getMetaXyear(2020).toString() + ' - ' + indicador.meta1 + ((indicador.unidad === 'Porcentaje') ? '%' : '')}</p>
              </div>
              <div className='text-information-report'>
                <label>Meta 2021</label>
                <p>{getMetaXyear(2021).toString() + ' - ' + indicador.meta2 + (indicador.unidad === 'Porcentaje' ? '%' : '')}</p>
              </div>
              <div className='text-information-report'>
                <label>Meta 2022</label>
                <p>{getMetaXyear(2022).toString() + ' - ' + indicador.meta3 + (indicador.unidad === 'Porcentaje' ? '%' : '')}</p>
              </div>
              <div className='text-information-report'>
                <label>Meta 2023</label>
                <p>{getMetaXyear(2023).toString() + ' - ' + indicador.meta4 + (indicador.unidad === 'Porcentaje' ? '%' : '')}</p>
              </div>
            </div>
          </div>
          <div className="kml-file-input-form flex-center-no-align">
            <div className={(state.textoError && !state.texto) ? 'kml-container-input border-error-color' : 'kml-container-input'}>
              <input
                placeholder='Descripción'
                type="text"
                className="kml-input"
                value={state.texto}
                onChange={props.handlerText}
              />
            </div>
            <div className={(state.valueError && !state.value) ? 'kml-container-input border-error-color' : 'kml-container-input'}>
              <input
                placeholder='Valor'
                type="number"
                className="kml-input"
                value={state.value}
                onChange={props.handlerValue}
              />
            </div>
          </div>
          <div className="kml-file-input-form flex-center-no-align">
            <Select
              placeholder='Seleccione anualidad'
              options={[
                { value: 2020 },
                { value: 2021 },
                { value: 2022 },
                { value: 2023 },
              ]}
              change={props.selectAnualidad}
              error={state.anualidadError}
              keyText='value'
            />
            <div className={(state.fechaError && !state.fecha) ? 'kml-container-input border-error-color' : 'kml-container-input'}>
              <input
                placeholder='Valor'
                type="date"
                className="kml-input"
                value={state.fecha}
                onChange={props.handlerDate}
              />
            </div>
          </div>
          <div className='file-tag-list-add-reporte text-center' >
            {
              getFileNames(state.addFiles)
            }
          </div>
          <div className="kml-file-input-form flex-center-no-align">
            <div onClick={props.fileSelect} className='kml-input-form-bottons gray-background-color on-mouse-hover' >
              <i className="far fa-file"></i>
            </div>
            <div onClick={props.save} className='kml-input-form-bottons primary-background-color on-mouse-hover'>
              <i className="fas fa-save"></i>
            </div>
          </div>
          <div className='dots-height'>
            {state.loading && <LoaderDots />}
          </div>
        </div>
      </div>

    </>
  )
}

export default AddReporte;